/**
 * Functions of the admin codebooks (sprint 7 §1, V26): every codebook has its own
 * `create / edit / delete`, so a role can be allowed to add manufacturers without touching
 * position kinds or attributes. Reading a codebook needs only a login, which is why there is
 * no `view`: the codebook's screen and menu item open for anyone who holds any of the three.
 * Units (sprint 5k) share the attributes screen, so its route and menu item open for either.
 */
export type CodebookModule = "location-kinds" | "position-kinds" | "attributes" | "units" | "manufacturers" | "suppliers";

/** The functions that open the codebook's screen (route `anyOf`, menu item, links to it). */
export function codebookWrite(module: CodebookModule): string[] {
  return [`${module}:create`, `${module}:edit`, `${module}:delete`];
}

/** The functions that open `/admin/atributi` — attributes and units live on one screen. */
export const ATTRIBUTES_SCREEN: string[] = [...codebookWrite("attributes"), ...codebookWrite("units")];
